var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData h100pct tableSys noBorder cSub mc",class:{ peN: _vm.text }},[_c('div',{staticClass:"h100pct"},[_c('Icon',{staticClass:"w21x fLight",attrs:{"name":"noData"}}),_vm._v(" "),_c('div',{staticClass:"mt1x"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1a6514","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ui/NoResult.vue
// module id = null
// module chunks = 